<template>
  <div class="form-group mb-3">
    <label :for="'input' + inputID" :class="noPadding ? '' : 'text-label'">
      {{ inputLabel }}&nbsp;
    </label>
    <input
      type="number"
      v-model.number="localNumber"
      :min="min"
      class="calc-input-width"
      :id="'input' + inputID"
      @input="handleInput"
    />
    <span v-if="per"> {{ t('per') }} </span>
    <select v-if="conversionFactors" aria-label="measurement input" class="units ms-1" :value="unit" @change="handleUnitChange">
      <option v-for="(unitOption, index) in unitOptions" :key="index" :value="unitOption">
        {{ unitOption }}
      </option>
    </select>
  </div>
</template>


<script>
import { ref, reactive, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'GenericInput',
  props: {
    inputLabel: {
      type: String,
      required: true,
      default: ''
    },
    modelValue: {
      type: Number,
      default: 0
    },
    conversionFactors: {
      type: Object,
      required: true
    },
    negative: {
      type: Boolean,
      default: false
    },
    per: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    invert: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const localNumber = ref(props.modelValue);
    const unit = ref(Object.keys(props.conversionFactors.to)[0]);
    const isInternalChange = ref(false);
    const min = computed(() => (props.negative ? -9999999999 : 0));
    const inputID = ref(Math.random().toString(36).substr(2, 9));

    const { t } = useI18n();

    // Create a reactive object with a function
    const translations = reactive({
      t: (key) => t(key)
    })

    const handleUnitChange = (event) => {
      unit.value = event.target.value;
      isInternalChange.value = true;
      convertAndEmit();
    };

    const convertAndEmit = () => {
      if (!isNaN(localNumber.value)) {
        const convertedValue = props.invert
          ? props.conversionFactors.from[unit.value](localNumber.value)
          : props.conversionFactors.to[unit.value](localNumber.value);
        
        emit('update:modelValue', convertedValue);
      }
    };

    watch(() => props.modelValue, (newVal) => {
      if (!isInternalChange.value && localNumber.value !== newVal) {
        localNumber.value = newVal;
      }
      isInternalChange.value = false;
    });

    // watch(unit, (newUnit) => {
    //   if (!isNaN(localNumber.value)) {
    //     const convertedValue = props.invert
    //       ? props.conversionFactors.from[newUnit](localNumber.value)
    //       : props.conversionFactors.to[newUnit](localNumber.value);
    //     emit('update:modelValue', convertedValue);

    //     console.log('unit changed');
    //     console.log('Local number: ' + localNumber.value);
    //     console.log('Converted number: ' + convertedValue);
    //   }
     
    // });

    const handleInput = () => {
      isInternalChange.value = true;
      emit('update:modelValue', localNumber.value);
    };

    const unitOptions = computed(() => {
      return Object.keys(props.conversionFactors.to);
    });

    return {  t: translations.t, localNumber, unit, inputID, unitOptions, isInternalChange, handleInput, min, convertAndEmit, handleUnitChange };
  }
};
</script>
